import { jsx as $ } from "react/jsx-runtime";
import { c as y } from "./index-65016bfa.mjs";
import { forwardRef as h } from "react";
import j, { css as e } from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as x } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
const N = j.div`
  &.AspectRatio {
    ${({
  theme: {
    components: { aspectRatio: t }
  },
  $style: o
}) => e(t.AspectRatio, o)};

    > * {
      ${({ $immediateChildStyle: t }) => e(t)};
    }
  }
`, g = h(
  ({
    width: t = "100%",
    height: o,
    minHeight: m,
    maxHeight: i,
    ratio: s,
    borderRadius: p,
    objectFit: c = "contain",
    objectPosition: a,
    variant: r = "none",
    className: n,
    children: l,
    ...R
  }, f) => {
    const u = x({ label: "Aspect Ratio" }), A = s == null ? void 0 : s.split(/[:/]/).map((d) => d.trim()).join("/");
    return /* @__PURE__ */ $(
      N,
      {
        ref: f,
        $style: {
          width: t,
          height: o,
          minHeight: m,
          maxHeight: i,
          borderRadius: p,
          aspectRatio: A
        },
        $immediateChildStyle: {
          objectFit: c,
          objectPosition: a
        },
        className: y(["AspectRatio", `AspectRatio--${r}`, n]),
        ...u,
        ...R,
        children: l
      }
    );
  }
);
export {
  g as AspectRatio
};
